import { useNavigate } from 'react-router';

export const useAdministrationController = () => {
  const navigate = useNavigate();

  const handleUserManagementClick = () => {
    navigate('/user-management');
  };

  const handleReportingClick = () => {
    navigate('/reporting');
  };

  return {
    handleUserManagementClick,
    handleReportingClick,
  };
};
